<template>
  <div class="top">
    <div class="topRight">
      <span class="a1">预约咨询</span>
    </div>
    <div class="logo">
      <img src="@/assets/img/logo.jpg" alt="">
    </div>
    <div class="menu" v-if="isShowmenu">
      <ul>
        <li @click="jumpTo(tab, index)" class="nli" v-for="(tab, index) in navTabs" :key="index">
          <span>{{tab.title}}</span>
        </li>
      </ul>
    </div>
    <div class="menuph" @click="showMenu">
      <div class="point mbtn bgColor">
        <span class="navbtn"></span>
      </div>
    </div>
    <div class="pf_menu_bg on" @click="showMenu" v-if="isShowmenu"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowmenu: false,
      navTabs: [
        { path: '/', title: '首页' },
        { path: '/about', title: '关于新界' },
        { path: '/search', title: '房源搜索' },
        { path: '/hui', title: '新界活动' },
        { path: '/customer', title: '企业客户' },
        { path: '/contact', title: '联系新界' }
      ]
    }
  },
  methods: {
    jumpTo (tab, index) {
      this.currentTab = index
      this.$router.push(tab.path)
      this.isShowmenu = false
    },
    showMenu () {
      this.isShowmenu = !this.isShowmenu
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  display: flex;
              align-items: center;
    justify-content: space-between;
  background: rgba(59 ,88, 91,0.9) !important;
  height: 50px;
  padding: 0 10px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  width: 100%;
  .logo {
    width: 200px;
    float: left;
    height: 60px;
    position: absolute;
    left: 50%;
    margin-left: -100px;
    img {
    height: 30px;
    width: 105px;
    margin-top: 12px;
    margin-left: 41px;
    }
  }
  .topRight {
    float: left;
    position: relative;
    span {
      font-size: 16px;
      display: inline-block;
      line-height: 60px;
      color: #fff;
      letter-spacing: 1px;
    }
  }
  .pf_menu_bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0 !important;
    z-index: 9;
    background: rgba(0,0,0,0.6);
  }
  .menu {
    z-index: 99;
    position: absolute;
    right: 0;
    top: 60px;
    width: 45%;
    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      .nli {
        margin-right: 20px;
        float: left;
        z-index: 99;
        position: relative;
        border-top: solid 1px #ddd;
        width: 100%;
        text-align: center;
        span {
          display: block;
          white-space: nowrap;
          width: 100%;
          float: left;
          line-height: 20px;
          padding: 20px 0;
          color: #333;
          font-size: 16px;
          position: relative;
          letter-spacing: 1px;
        }
      }
    }
  }
  .menuph {
    float: right;
    cursor: pointer;
    width: 40px;
    height: 60px;
    text-align: center;
    display: block;
    .point {
      display: inline-block;
      width: 40px;
      height: 40px;
      margin-top: 10px;
      position: relative;
      border-radius: 50%;
    }
    .navbtn {
      position: absolute;
      top: 16px;
      left: 8px;
      display: inline-block;
      width: 24px;
      height: 1px;
      transition: all .3s ease-out 0s;
      background: #fff;
      &:before {
        top: 6px;
        position: absolute;
        left: 0;
        display: inline-block;
        width: 24px;
        height: 1px;
        content: '';
        transition: all .3s ease-out 0s;
        background: #fff;
      }
      &:after {
        top: -6px;
        width: 8px;
      }
    }
  }
}
</style>
